import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../../../services/api";
import Spinner from "../../../elements/Spinner";
import swal from "sweetalert";
import { Modal, Button } from "react-bootstrap";
import Pagination from "../../../elements/Pagination";
import Select from "react-select";
import $ from "jquery";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.mjs";

export default function Machines(props) {
  const [spinner, setSpinner] = useState(false);
  const history = useHistory();
  const [searchValue, setSearchValue] = useState("");
  const [companies, setCompanies] = useState([]);

  const getCompanies = async () => {
    setSpinner(true);
    var response = await api.post("/companies", { type: "Own" });
    if (response.status === 200 && response.data) {
      setCompanies(response.data.data);
    } else {
      console.log(response.data);
    }
    setSpinner(false);
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const [filterData, setFilterData] = useState({
    company_id: "",
  });

  const clearFields = () => {
    setFilterData({ company_id: "" });
  };

  const filterChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const dataTableRef = useRef(null);
  const [machines, setMachines] = useState([]);
  const getMachines = async () => {
    setSpinner(true);
    var response = await api.post("/machines", {
      search: searchValue,
      company_id: filterData.company_id,
    });
    if (response.status === 200 && response.data) {
      setMachines(response.data.machines);
    } else {
      console.log(response.data);
    }
    setSpinner(false);
  };

  useEffect(() => {
    const fetchDataAndInitializeDataTable = async () => {
      setSpinner(true);
      await getMachines();
      // Destroy existing DataTable to reset with new data
      if ($.fn.DataTable.isDataTable(dataTableRef.current)) {
        $(dataTableRef.current).DataTable().destroy();
      }

      const dataTable = $(dataTableRef.current).DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "copy",
            exportOptions: { columns: ":visible" },
          },
          {
            extend: "excel",
            exportOptions: { columns: ":visible" },
          },
          {
            extend: "print",
            exportOptions: {
              columns: function (idx, data, node) {
                return true;
              },
            },
            customize: function (win) {
              var newTitle = $("<h6>")
                .css("text-align", "left")
                .html("MACHINE LIST");
              newTitle.insertAfter($(win.document.body).find("h1"));
            },
          },
        ],
        paging: false,
        info: false,
        searching: false,
        order: [[0, "desc"]],
      });

      setSpinner(false);
    };

    fetchDataAndInitializeDataTable();

    // Cleanup DataTable on unmount
    return () => {
      if ($.fn.DataTable.isDataTable(dataTableRef.current)) {
        $(dataTableRef.current).DataTable().destroy();
      }
    };
  }, [machines]);


  useEffect(() => {
    getMachines();
  }, [searchValue, filterData]);


  return (
    <div className="create_edit_page">
      {spinner && <Spinner />}
      <div className="create_page_heading">
        <div className="page_name">Machines</div>
        <div className="actions">
          {props.userData.department_title === "Maintenance" ||
          props.userData.designation_title === "Manager" ? (
            <Link
              to="/maintenance/machines-create"
              className="btn btn-warning bg-falgun rounded-circle"
            >
              <i className="fal fa-plus"></i>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="datrange_filter non_printing_area">
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Company</label>
              <select
                value={filterData.company_id}
                className="form-select"
                name="company_id"
                onChange={(event) =>
                  filterChange("company_id", event.target.value)
                }
              >
                <option value="">All</option>
                {companies.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col">
            <div className="form-group">
              <label>Search</label>
              <input
                type="search"
                onChange={(e) => setSearchValue(e.target.value)}
                value={searchValue}
                className="form-control"
                placeholder="Search"
              />
            </div>
          </div>
          <div className="col">
            <br />
            <Button onClick={clearFields} className="btn btn-warning btn-sm">
              <i className="fas fa-retweet"></i>
            </Button>{" "}
          </div>
        </div>
      </div>

      <div className="employees_tables">
        <div id="buttonsContainer"> </div>
        <table ref={dataTableRef} className="display">
          <thead>
            <tr>
              <th>SL</th>
              <th>THUMB</th>
              <th>TITLE</th>
              <th>MODEL</th>
              <th>BRAND</th>
              <th>TYPE</th>
              <th>UNIT</th>
              <th>REF</th>
              <th>EFFICIENCY</th>
              <th>COMPANY</th>
              <th>OWNERSHIP</th>
              <th>CATEGORY</th>
              <th>VALUE</th>
              <th>STATUS</th>
              {/* <th>ACTION</th> */}
            </tr>
          </thead>
          <tbody>
            {machines.length > 0 &&
              machines.map((item, index) => (
                <tr
                  key={index}
                  className={item.status === "Inactive" ? "Pending" : "Placed"}
                >
                  <td>
                    {index + 1} | {item.serial_number}
                  </td>
                  <td>
                    <img
                      // onClick={() => openImageModal(item.image_source)}
                      style={{
                        width: "50px",
                        height: "50px",
                        border: "1px solid gray",
                        borderRadius: "3px",
                        cursor: "pointer",
                      }}
                      src={item.image_source}
                    />
                  </td>
                  <td>{item.title}</td>
                  <td>{item.model}</td>
                  <td>{item.brand}</td>
                  <td>{item.type}</td>
                  <td>{item.unit}</td>
                  <td>{item.reference}</td>
                  <td>{item.efficiency} %</td>
                  <td>{item.company}</td>
                  <td>{item.ownership}</td>
                  <td>{item.category}</td>
                  <td>{item.purchase_value}</td>
                  <td>{item.status}</td>
                  {/* <td>
                    <Link to={"/maintenance/machines-edit/" + item.id}>
                      <i className="fa fa-pen"></i>
                    </Link>
                  </td> */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
